export enum PromoCodeErrorResponse {
    NoDiscount = "no_discount",
    Expired = "expired",
    CompanyBalanceUsedUp = "company_balance_used_up",
    LoginRequired = "login_required",
    NoPsychologist = "no_psychologist",
    NoRemainder = "no_remainder",
    CanNotBeAppliedByThisEmail = "can_not_be_applied_by_this_email",
    UnavailableForClient = "unavailable_for_client",
    UnsuitablePsychologist = "unsuitable_psychologist",
    NoOfferedService = "no_offered_service",
    PriceLimitExceeded = "price_limit_exceeded",
    Duplicate = "duplicate",
    NotAvailableForB2B = "not_available_for_b2b",
}

export interface DiscountByPromoCodeResponse {
    id: number
}
